"use client";

import dynamic from "next/dynamic";

interface Industry {
  imageUrl: string;
  screenUrl: string;
  title: string;
  description: string;
  link: string;
}

interface IndustryCarouselIndustryProps {
  industries: Industry[];
  imgBaseUrl: string;
  textCenter?: boolean;
  noScreen?: boolean;
  forBlog?: boolean;
}

const Carousel = dynamic(() => import("./IndustryCarousel"), {
  loading: () => (
    <div className="h-96 bg-gray-100 animate-pulse rounded-lg flex items-center justify-center">
      <div className="text-gray-500">Loading industries...</div>
    </div>
  ),
});

export default function IndustryCarouselIndustry({
  industries,
  imgBaseUrl,
  textCenter = true,
  noScreen = false,
  forBlog = false,
}: IndustryCarouselIndustryProps) {
  return <Carousel industries={industries} imgBaseUrl={imgBaseUrl} textCenter={textCenter} noScreen={noScreen} forBlog={forBlog} />;
}
